import { isEmpty } from 'lodash'
import PrismaUser from 'models/data/prisma/PrismaUser'
import Time from 'models/data/utils/Time';

class PrismaToApiUser {
    static subscriptionHasExpired = prismaUser => {
		return PrismaUser.stripeSubscriptionEndsAt(prismaUser) <= Time.secondsSinceEpoch()
	}

    static hasSubscription = prismaUser => !isEmpty(PrismaUser.stripeSubscriptionId(prismaUser))

	static map = prismaUser => ({
		id: PrismaUser.id(prismaUser),
		firebaseId: PrismaUser.firebaseId(prismaUser),
		firstName: PrismaUser.firstName(prismaUser),
		lastName: PrismaUser.lastName(prismaUser),
		stripeCustomerId: PrismaUser.stripeCustomerId(prismaUser),
        stripePlanId: PrismaUser.stripePlanId(prismaUser),
        hasSubscription: PrismaToApiUser.hasSubscription(prismaUser),
        stripeSubscriptionEndsAt: PrismaUser.stripeSubscriptionEndsAt(prismaUser),
        subscriptionHasExpired: PrismaToApiUser.subscriptionHasExpired(prismaUser),
		stripeSubscriptionId: PrismaUser.stripeSubscriptionId(prismaUser),
		email: PrismaUser.email(prismaUser),
        referralCode: PrismaUser.referralCode(prismaUser),
		appStoreToken: PrismaUser.appStoreToken(prismaUser)
	});
}

export default PrismaToApiUser;